export default __webpack_public_path__ + "static/media/gallery-wip-emitter-shroud_07.ab66f11d.jpg";